import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

function ForgotAccess() {
  const navigate = useNavigate();

  const [mode, setMode] = useState("phone");
  const [formData, setFormData] = useState({
    phone: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (mode === "phone") {
        if (!formData.phone.trim()) {
          throw new Error("Phone number is required.");
        }

        const { error } = await supabase.auth.signInWithOtp({
          phone: formData.phone.trim(),
          options: {
            shouldCreateUser: false,
          },
        });

        if (error) throw error;

        sessionStorage.setItem(
          "mistribazaarOtpRecovery",
          JSON.stringify({
            mode: "phone",
            phone: formData.phone.trim(),
          })
        );
      } else {
        if (!formData.email.trim()) {
          throw new Error("Email is required.");
        }

        const { error } = await supabase.auth.signInWithOtp({
          email: formData.email.trim(),
          options: {
            shouldCreateUser: false,
          },
        });

        if (error) throw error;

        sessionStorage.setItem(
          "mistribazaarOtpRecovery",
          JSON.stringify({
            mode: "email",
            email: formData.email.trim(),
          })
        );
      }

      alert("OTP sent.");
      navigate("/otp-recovery-verify");
    } catch (error) {
      console.error("Forgot access OTP error:", error);
      alert(error.message || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <div style={card} className="otp-page__card">
        <h1>Recover Account Access</h1>
        <p style={{ color: "#d1d1d1" }}>
          Use OTP to get back into your account if you forgot your password.
        </p>

        <form onSubmit={handleSendOtp}>
          <label style={label}>Recovery Method</label>
          <select value={mode} onChange={(e) => setMode(e.target.value)} style={input}>
            <option value="phone">Phone OTP</option>
            <option value="email">Email OTP</option>
          </select>

          {mode === "phone" ? (
            <input
              name="phone"
              placeholder="+91XXXXXXXXXX"
              value={formData.phone}
              onChange={handleChange}
              required
              style={input}
            />
          ) : (
            <input
              name="email"
              type="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
              style={input}
            />
          )}

          <button type="submit" disabled={loading} style={button}>
            {loading ? "Sending OTP..." : "Send OTP"}
          </button>
        </form>
      </div>
    </div>
  );
}

const page = {
  background: "radial-gradient(circle at top, #101010 0%, #000 55%)",
  minHeight: "100vh",
  padding: "40px 20px",
  color: "#fff",
  fontFamily: "Arial, sans-serif",
};

const card = {
  maxWidth: "520px",
  margin: "0 auto",
  background: "#111",
  padding: "24px",
  borderRadius: "18px",
  border: "1px solid #2a2a2a",
};

const label = {
  display: "block",
  marginBottom: "8px",
  marginTop: "12px",
  color: "#fff",
};

const input = {
  width: "100%",
  padding: "12px 14px",
  marginBottom: "14px",
  borderRadius: "10px",
  border: "1px solid #2a2a2a",
  background: "#0b0b0b",
  color: "#fff",
  boxSizing: "border-box",
};

const button = {
  width: "100%",
  padding: "12px 16px",
  borderRadius: "10px",
  border: "none",
  background: "#fff",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer",
};

export default ForgotAccess;
